import { LoadingButton } from '@mui/lab';
import { omit, omitBy } from 'lodash';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useLazyGetExcelFileMapitShipForAdminQuery, useLazyGetExcelFileMapitShipQuery } from 'src/_api/mapitShipApi';
import { DownloadExcelDialog } from 'src/_modules/common';

export default function ExportMapitShipOrders({
    status,
    params,
    isAdmin
}) {

    const { t } = useTranslation();

    const [openExcelDialog, setOpenExelDialog] = React.useState(false);

    const openDialogExcel = () => {
        setOpenExelDialog(true);
    };

    const closeExcelDialog = () => {
        setOpenExelDialog(false);
    };

    const showExportButton = !["ORDER_CANCELED", "ORDER_PENDING", "ALL_ORDERS"].includes(
        status,
    );

    //==================== Download Excel file //====================================

    const [
        triggerGetExcelByAdmin,
        { isLoading: loadingExcelAdmin, error: errorExcelAdmin, isSuccess: successExcelAdmin },
    ] = useLazyGetExcelFileMapitShipForAdminQuery();

    const [triggerGetExcelByMerchant,
        { isLoading: loadingExcelMerchant, error: errorExcelMerchant, isSuccess: successExcelMerchant }
    ] = useLazyGetExcelFileMapitShipQuery();

    const loadingExcel = isAdmin ? loadingExcelAdmin : loadingExcelMerchant;
    const errorExcel = isAdmin ? errorExcelAdmin : errorExcelMerchant;
    const successExcel = isAdmin ? successExcelAdmin : successExcelMerchant;

    const triggerGetExcel = isAdmin ? triggerGetExcelByAdmin : triggerGetExcelByMerchant;

    const onExcelDownload = async ({ email }) => {
        const payload = omitBy(omit(params, ["page", "limit"]), (v) => !v);

        await triggerGetExcel({
            ...payload,
            email,
        }).unwrap();
    };

    // Close the dialog when excel file is successfully downloaded

    useEffect(() => {
        if (successExcel) {
            closeExcelDialog();
        }
    }, [successExcel])


    return (
        <>
            {showExportButton && (
                <>
                    <LoadingButton
                        loading={loadingExcel}
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="success"
                        onClick={openDialogExcel}
                    >
                        {t("Excel")}
                    </LoadingButton>
                    <DownloadExcelDialog
                        open={openExcelDialog}
                        onClose={closeExcelDialog}
                        onSend={onExcelDownload}
                        loading={loadingExcel}
                        error={errorExcel}
                        isSuccess={successExcel}
                    />
                </>
            )}
        </>
    )
}
